import React from 'react'
import QRCode from 'react-qr-code'
import { QRCode as QRCodeCanvas } from 'react-qrcode-logo'
import Barcode from 'react-barcode'
import HttpServices from '../../utils/Http.services'
import { toHalfFloat } from 'three/src/extras/DataUtils.js'


class BarCodeGeneratorInput extends React.Component {
    state = {
        code: '',
        decoded: '',
        err: null
    }

    // CAPITALNUMBERLIST = 'ABCDEFJHIJKLMNOPQRSTUVWXYZ1234567890'
    CAPITALNUMBERLIST = '1234567890'

    constructor(props) {
        super(props);

        // Create a debounced version of changeInputValue
        this.debouncedChangeInputValue = this.debounce(this.changeInputValue, 1000);
    }

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    generateCode = () => {
        const { header, extra, changeValue, variables } = this.props
        const info = header?.information
        const appletId = variables.appletId

        if (!appletId) {
            this.setState({ err: 'appletId is required to generate the code!' }, () => {
                setTimeout(() => {
                    this.setState({ err: null })
                }, 2000)
            })
            return
        }


        let body = { appletId: appletId }

        HttpServices.request('generateProductBarcode', body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({
                    type: 'error',
                    title: '{{lang}}errors.fetchDataFailed',
                    description: fetchError.message
                })
                return
            }

            if (fetchResult.barcode) {
                this.setState({ err: null, code: String(fetchResult.barcode) })
                // console.log('aaaaaaaaaaaaaaaaa',fetchResult.barcode);
                changeValue(header.key, fetchResult.barcode, extra)
            } else {
                this.setState({ err: 'Failed to generate! It would be regenerated automatically' }, () => {
                    setTimeout(() => {
                        this.generateCode()
                    }, 200)
                })
            }
        })


    }
componentDidMount(){
    if(this.props.data){
        this.setState({code:this.props.data})
    }
}
    checkAvailable = (barcode, cb) => {
        let body = { barcode }

        HttpServices.request('getOneProductWithBarcode', body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({
                    type: 'error',
                    title: '{{lang}}errors.fetchDataFailed',
                    description: fetchError.message
                })
                return
            }

            if (fetchResult.exist) {
                cb(null, true)
            } else {
                cb(true, null)
            }
        })
    }

    decodeCode = () => {
        const { code } = this.state
        if (!code) return

        try {
            const shortHash = code.split('-')[0]
            const decoded = `yonnect.com-${shortHash}`
            this.setState({ decoded })
        } catch (e) {
            this.setState({ decoded: 'Invalid code' })
        }
    }

    changeInputValue = (target) => {
        let value = target.validity.valid ? target.value : null
        if (value !== null) {
            this.checkAvailable(value, (available, exist) => {
                if (available) {
                    this.props.changeValue(this.props.header.key, value, this.props.extra)
                } else {
                    this.setState({ err: 'This barcode is already taken! It would be regenerated automatically' }, () => {
                        setTimeout(() => {
                            this.generateCode()
                        }, 2000)
                    })
                }
            })


        }
    }

    render() {
        const { styleInfo, data, header } = this.props
        const { code, decoded, err } = this.state


        return (
            <div className=" scroll-no-scrollbar w-100  flexc flex-column" style={{ maxHeight:'150px' }}>
                <div className="w-100  flexc flex-row">
                    <input
                        style={{
                            color: styleInfo?.textColor,
                            fontWeight: styleInfo?.fontWeight,
                            fontSize: styleInfo?.fontSize
                        }}
                        ref={el => (this.input = el)}
                        autoFocus={header.information?.autoFocus}
                        spellCheck={header.information?.spellCheck}
                        value={data || ''}
                        onChange={(e) => this.debouncedChangeInputValue(e.target)} // Use the debounced version
                        placeholder={header.information?.placeholder}
                        disabled={header.information?.disabled}
                        className="transpanet-input"
                    />

                    <div className="flex-row mt-2">
                        <button className="text-link mx-2" onClick={this.generateCode}>
                            <p>Generate</p>
                        </button>
                    </div>
                </div>

                {/* {code && (
                    <div className="w-100 code-display flex-column mt-2" >
                     
                        <div  className=" w-100 row flexcc mt-2">
                        
                            <div className="mx-4">
                                <QRCode value={code} size={50} />
                            </div>

                        
                            <div className="mx-4">
                                <QRCodeCanvas
                                    value={code}
                                    size={50}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    logoImage="/logo-w.svg"
                                    logoWidth={15}
                                    logoHeight={15}
                                    eyeColor="#000000"
                                />
                            </div>
                        </div>

                      
                        <div className=" flexcc w-100" style={{ transform: 'scale(0.5)' }}>
                            <Barcode value={code} format="CODE128" />
                        </div>
                    </div>
                )} */}

                {err && (
                    <div className="err-output mt-2 fs-9" style={{ color: '#ee5050' }}>
                        <p>{err}</p>
                    </div>
                )}
                {decoded && (
                    <div className="decoded-output mt-2">
                        <p>Decoded: {decoded}</p>
                    </div>
                )}
            </div>
        )
    }
}

export default BarCodeGeneratorInput
